import { Padlock } from "components/icons/Padlock";
import ToolTip from "components/design/toolTip";
import { Button, ButtonProps } from "./Button";

type LockedButtonProps = {
  text?: string;
  customType?: ButtonProps["customType"];
  size?: ButtonProps["size"];
};

export const LockedButton = ({
  text,
  customType = "secondary",
  size = "small",
}: LockedButtonProps) => {
  const padlock = <Padlock showTooltip={false} />;

  return (
    <ToolTip text="You have read-only access">
      <span>
        <Button
          size={size}
          customType={customType}
          leftIcon={text ? padlock : undefined}
          disabled
        >
          {text ?? padlock}
        </Button>
      </span>
    </ToolTip>
  );
};
